import fetchAPI from '../fetchAPI';

export interface UpdateKeyPayload {
  locationIds: string[];
  expiresAt?: string | null;
}

export const callUpdateKey = async (id: string, data: UpdateKeyPayload): Promise<iResponse<{ data: Keys }>> => {
  const response: iResponse<{ data: Keys }> = await fetchAPI({
    method: `PATCH`,
    route: `api-key/${id}`,
    data
  });

  return response;
};

export default callUpdateKey;
